module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/.6.26.0@babel-runtime/core-js/is-iterable.js
// module id = 595
// module chunks = 1